import React from 'react';
import { Box, TableCell, useTheme } from '@mui/material';
import { SortIcon } from './sortIcon';

// 정렬 가능한 테이블 헤더 셀 컴포넌트
const SortableHeaderCell = ({
    columnKey,
    label,
    sortConfig,
    onSort,
    align = 'left',
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    return (
        <TableCell
            onClick={() => onSort(columnKey)}
            sx={{
                cursor: 'pointer',
                userSelect: 'none',
                textAlign: align,
                backgroundColor: theme.palette.figma.white[10],
                '&:hover': {
                    backgroundColor: theme.palette.figma.white[20],
                },
                ...sx
            }}
            {...props}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start' }}>
                {label}
                <SortIcon sortConfig={sortConfig} columnKey={columnKey} />
            </Box>
        </TableCell>
    );
};

// 일반 테이블 헤더 셀 컴포넌트 (정렬 불가)
const HeaderCell = ({
    label,
    align = 'left',
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    return (
        <TableCell
            sx={{
                textAlign: align,
                backgroundColor: theme.palette.figma.white[10],
                ...sx
            }}
            {...props}
        >
            {label}
        </TableCell>
    );
};

export { SortableHeaderCell, HeaderCell };
